import { atom } from 'jotai';

/**
 * Refcount of form roots that report blocking dirty state while the current user is ATG admin.
 * Used by CompanySwitcher to prompt before switching company context. Writers must be gated
 * (see useRegisterAtgAdminCompanySwitchDirty) so non-admins never increment this atom.
 */
export const atgAdminCompanySwitchDirtyCountAtom = atom(0);
